import { useEffect } from 'react'
import { _setFeatureFlags } from '@carto/react-core'
import * as ld from 'launchdarkly-js-client-sdk'

import { useAppDispatch, useAppSelector } from 'app/state'
import { getFeatureFlagOverrides } from 'app/state/featureFlags'
import { setFeatureFlagOverrides } from 'features/common/state/commonSlice'

import { selectActualFeatureFlags } from './useFeatureFlag'
import { useFeatureFlagsFromLd } from './useFeatureFlagsFromLd'

export function useInitializeFeatureFlags(props: { ldContext?: ld.LDContext }) {
  const dispatch = useAppDispatch()
  const allFlags = useAppSelector(selectActualFeatureFlags)

  useFeatureFlagsFromLd(props.ldContext)

  // sync feature flags with carto4react
  useEffect(() => {
    _setFeatureFlags(allFlags)
  }, [allFlags])

  // load feature flag overrides
  useEffect(() => {
    const featureFlagOverrides = getFeatureFlagOverrides()
    if (featureFlagOverrides) {
      dispatch(setFeatureFlagOverrides(featureFlagOverrides))
    }
  }, [dispatch])
}
